import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';

import {
  faClone,
  faQrcode
} from '@fortawesome/pro-light-svg-icons';


import classNames from 'classnames';

import { currentProjectActiveDomainsSelector } from '../../reducers/selectors';
import shortUrl from '../helpers/ShortUrl';

import ModalLink from '../modals/ModalLink';

const mapStateToProps = state => ({ domains: currentProjectActiveDomainsSelector(state), links: state.links });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
};

class ShorbyLink extends Component {
  // Dashulya I Love You ❤️!
  
  constructor(props) {
    super(props);
    this.onCopy = this.onCopy.bind(this);
    
    this.state = {
      ...this.state,
      copied: false
    };
  }
  
  preventClick(e){
    if (e && e.preventDefault)
      e.preventDefault();
  }
  stopPropagation(e){
    if (e && e.stopPropagation)
      e.stopPropagation();
  }
  onCopy(e) {
    this.setState({copied: true})
    setTimeout(() => this.setState({copied: false}), 1000);
  }
  
  render() {
    const { link, copyOnLinkClick, domains, links } = this.props;
    const short_url = link.short_url || shortUrl({...link, domains, links});
    const linkName = (short_url || '').replace(/^https?:\/\//, '');
    
    return (<span className={classNames({"shor-link": true, "copied": this.state.copied})}>
      { copyOnLinkClick === true? <CopyToClipboard text={short_url} onCopy={this.onCopy}>
          <a href={short_url} data-shadow={linkName} title={link.url || short_url} target="_blank" onClick={this.preventClick}>{linkName}</a>
        </CopyToClipboard>
      :
        <a href={short_url} data-shadow={linkName} title={link.url || short_url} target="_blank" onClick={this.stopPropagation}>{linkName}</a>
      }
      <CopyToClipboard text={short_url} onCopy={this.onCopy}><span className="show-on-hover clickable-icon link-copy-icon" onClick={this.preventClick}>  <FA icon={faClone} /></span></CopyToClipboard>
      <ModalLink to="shareLink" params={{short_url, slug: (link.slug || link.custom_slug || link.unique_slug)}} className="show-on-hover clickable-icon nounderline link-qrcode-icon"> <FA icon={faQrcode} /></ModalLink>
    </span>)
  }
}


export default connect(mapStateToProps, matchDispatchToProps)(ShorbyLink);


// WEBPACK FOOTER //
// ./src/components/Links/ShorbyLink.js